import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { EnumeratorList } from '../models/enumerators-list';
import { MatDialog } from '@angular/material/dialog';
import { PopUpComponent } from '../components/pop-up/pop-up.component';
import { DialogBoxComponent } from '../components/dialog-box/dialog-box.component';
import { DisplayDialogComponent } from '../components/display-dialog/display-dialog.component';

@Injectable({
    providedIn: 'root'
})

export class UtilityService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    constructor(
        private l_ToasterService: ToastrService, 
        private router: Router,
        private dialog: MatDialog
    ) {}

    lFN_SuccessToaster(message: string, tagline: string) {
        this.l_ToasterService.success(message, tagline, {
            timeOut: 2000,
            positionClass: 'toast-top-right',
            progressBar: true
        });
    }

    lFN_ErrorToaster(message: string, tagline: string) {
        this.l_ToasterService.error(message, tagline, {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true
        });
    }

    lFN_WarningToaster(message: string, tagline: string) {
        this.l_ToasterService.warning(message, tagline, {
            timeOut: 4000,
            positionClass: 'toast-top-right',
            progressBar: true
        });
    }

    lFN_CustomSuccessToaster(message: string, tagline: string, duration: number) {
        this.l_ToasterService.success(message, tagline, {
            timeOut: duration,
            positionClass: 'toast-top-right',
            progressBar: true
        });
    }

    lFN_CustomErrorToaster(message: string, tagline: string, duration: number) {
        this.l_ToasterService.error(message, tagline, {
            timeOut: duration,
            positionClass: 'toast-top-right',
            progressBar: true
        });
    }

    lFN_CustomWarningToaster(message: string, tagline: string, duration: number) {
        this.l_ToasterService.warning(message, tagline, {
            timeOut: duration,
            positionClass: 'toast-top-right',
            progressBar: true
        });
    }

    lFN_ShowLoader() {
        this.loadingSubject.next(true);
    }

    lFN_HideLoader() {
        this.loadingSubject.next(false);
    }

    lFN_NavigateViaExtras(path: string, dataobject: any, navigateMode: string) {
        this.router.navigate(['/'+path], {
            state: { data: dataobject, mode: navigateMode }
        });
    }

    lFN_Navigate(path: string, navigateMode: string) {
        this.router.navigate(['/'+path], {
            state: { mode: navigateMode }
        });
    }

    async lFN_GetModePaymentList(txncategory: string, purpose: string) {
        let l_modeOfPaymentList: { value: string, viewValue: string }[] = [];
        let l_modeOfPaymentEnum = new EnumeratorList().modeOfPaymentEnum;

        if (txncategory === 'Yogprakash') {
            l_modeOfPaymentList = [
                { value: 'Cash', viewValue: 'Cash' },
                { value: 'Online via PhonePe', viewValue: 'Online via PhonePe' },
                { value: 'Cheque', viewValue: 'Cheque' },
                { value: 'NEFT', viewValue: 'NEFT' },
                { value: 'DD', viewValue: 'DD' }
            ];
        }
        else if(txncategory === 'Pariksha') {
            l_modeOfPaymentList = [
                { value: 'Cash', viewValue: 'Cash' }
            ];
        }
        else if(txncategory === 'Books and Materials') {
            if(purpose === 'Books Materials Sale Via Cash') {
                l_modeOfPaymentList = [
                    { value: 'Cash', viewValue: 'Cash' }
                ];
            } else {
                l_modeOfPaymentList = [
                    { value: 'Online via PhonePe', viewValue: 'Online via PhonePe' },
                    { value: 'Cheque', viewValue: 'Cheque' },
                    { value: 'DD', viewValue: 'DD' },
                    { value: 'NEFT', viewValue: 'NEFT' }
                ];
            }
        }
        else if(txncategory === 'Donation') {
            if(purpose === 'Donation Via Cash') {
                l_modeOfPaymentList = [
                    { value: 'Cash', viewValue: 'Cash' }
                ];
            } else if(purpose === 'Donation for Yadnya' || purpose === 'Donation for General Building Fund' || purpose === 'Yog Sammelan Donation') {
                l_modeOfPaymentList = [
                    { value: 'Cash', viewValue: 'Cash' },
                    { value: 'Online via PhonePe', viewValue: 'Online via PhonePe' },
                    { value: 'Cheque', viewValue: 'Cheque' },
                    { value: 'DD', viewValue: 'DD' },
                    { value: 'NEFT', viewValue: 'NEFT' },
                    { value: 'RTGS', viewValue: 'RTGS' }
                ];
            } else {
                l_modeOfPaymentList = [
                    { value: 'Online via PhonePe', viewValue: 'Online via PhonePe' },
                    { value: 'Cheque', viewValue: 'Cheque' },
                    { value: 'DD', viewValue: 'DD' },
                    { value: 'NEFT', viewValue: 'NEFT' },
                    { value: 'RTGS', viewValue: 'RTGS' }
                ];
            }
        }

        return l_modeOfPaymentList;
    }    

    async lFN_ShowPopup(l_title, l_data) {
        this.dialog.open(PopUpComponent, {
            width: '1200px',
            height: '450px',
            data: l_data
          });
    }

    lFN_ShowConfirmationDialog(l_title: string, l_message: string, l_buttonsList: any[]) {
        const dialogRef = this.dialog.open(DialogBoxComponent, {
            width: '400px',
            data: {
            title: l_title,
            message: l_message,
            buttons: l_buttonsList
            }
        });

        return dialogRef.afterClosed();
    }

    lFN_FormatCurrency(value: string): string {
        if (!value) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        let numericValue = value.replace(/,/g, '');
        numericValue = numericValue.replace(/[^0-9.]/g, '');

        // Split the integer and decimal parts
        const parts = numericValue.split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1] ? '.' + parts[1] : '';

        // Format the integer part with commas (Indian format)
        if(integerPart.length > 3) {
            const lastThree = integerPart.slice(-3);
            const otherNumbers = integerPart.slice(0, -3);
            const formattedIntegerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
            console.log('indianCurrFormat == ', formattedIntegerPart + decimalPart);
            return formattedIntegerPart + decimalPart;
        } else {
            return integerPart + decimalPart;
        }
    }

    lFN_FormatCurrencyForDisplay(value: number): string {
        if (!value) return '';
    
        // Split the number into integer and decimal parts
        const [integerPart, decimalPart] = value.toString().split('.');
    
        // Format the integer part with commas
        let formattedIntegerPart = '';
        if (integerPart.length > 3) {
            const lastThree = integerPart.slice(-3);
            const otherNumbers = integerPart.slice(0, -3);
            formattedIntegerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
        } else {
            formattedIntegerPart = integerPart;
        }
    
        // If there's a decimal part, append it
        if (decimalPart) {
            return formattedIntegerPart + '.' + decimalPart;
        } else {
            return formattedIntegerPart;
        }
    }    

    async lFN_GetReceiptNotesList(txncategory: string) {
        let l_receiptNotesList: string[] = [];
        if (txncategory === 'Yogprakash') {
            l_receiptNotesList = [
                'Yogprakash Magazine Subscription',
                'Advertisement for Yogprakash',
                'Diwali Advertisement for Yogprakash',
                'Donation Received for Yogprakash'
            ];
        }
        else if(txncategory === 'Pariksha') {
            l_receiptNotesList = [
                'Yog Parichay Pariksha',
                'Yog Pravesh Pariksha',
                'Yog Pravin Pariksha'
            ];
        }
        else if(txncategory === 'Books and Materials') {
            l_receiptNotesList = [
                'Sale Books and Materials'
            ];
        }
        else if(txncategory === 'Donation') {
            l_receiptNotesList = [
                'Donation to Mandal',
                'Donation for Birthday',
                'Donation for Anniversary',
                'Donation for Gurupournima',
                'Donation for Samaradhana',
                'Donation for Jayanti',
                'Donation by Yogopchaar Patient',
                'Donation by Yog Varga Sadhak',
                'Donation in Memory of Father',
                'Donation in Memory of Mother',
                'Donation for Yog Sammelan'
            ];
        }
        return l_receiptNotesList;
    }

    async lFN_DisplayModal(l_data: any) {
        this.dialog.open(DisplayDialogComponent, {
            width: '50%',
            //height: '450px',
            data: l_data
          });
    }    

    
    
}